import Vue from 'vue';

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
Vue.component('v-select-c', vSelect);

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

import Toasted from 'vue-toasted';
Vue.use(Toasted)

Vue.component('form-contact-expo-vivienda', require('../pages/contact-expo-vivienda/FormContactExpoVivienda.vue').default);

Vue.config.productionTip = false;
Vue.config.devtools = false;

if (document.getElementById("vue-form-contact-expo-vivienda")) {
    new Vue({
        el: '#vue-form-contact-expo-vivienda',
    });
}
